export default "__VITE_ASSET__4c3349d3__"